module.exports = __webpack_public_path__ + "static/img/post_01.4898d94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/post_01.jpg
// module id = E9wA
// module chunks = 0